// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-modal-tooltip[data-v-137643c4]{cursor:pointer}", "",{"version":3,"sources":["webpack://./modules/frontend/themes/whocanfixmycar/assets/js/components/Partials/Services.vue"],"names":[],"mappings":"AACI,wCACI,cAAR","sourcesContent":["\n    .service-modal-tooltip {\n        cursor: pointer;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
